<template>
    <div class="flex flex-row justify-between flex-wrap w-full h-fit z-20 items-baseline">
      <!-- Warnings -->
      <div  class="pt-5 pb-4 h-fit w-full flex flex-row h-fit flex-wrap justify-between  items-baseline ">
        <div class="flex flex-row flex-wrap  h-fit">
          <header-warnings v-for="item in warnings" :key="item.id" :warningData="item"></header-warnings>
        </div>
        <div v-if="loaded" :class="'flex flex-row flex-wrap sm:space-y-0 '+ style ">
          <button v-if="erpConnectionStatus.isEventRecent" @click="navigateToSyncStatus" type="button" value="off"
              class="inline-flex items-center mr-4 px-3 py-2 gap-x-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm"
              :class="erpConnectionStatus.isActive ? 'border-green-500 bg-green-50 text-green-700' : 'border-red-500 bg-red-50 text-red-700'"
          >
            <span class="relative flex h-3 w-3">
              <span v-if="!erpConnectionStatus.isActive" class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75" :class="erpConnectionStatus.isActive ? 'bg-green-400' : 'bg-red-400'"></span>
              <span class="relative inline-flex rounded-full h-3 w-3" :class="erpConnectionStatus.isActive ? 'bg-green-600' : 'bg-red-600'"></span>
            </span>
            {{displayErpName(erpConnectionStatus.erpType)}} {{ erpConnectionStatus.isActive ? $t('header.connection.up') : $t('header.connection.down') }}
            <span v-if="erpConnectionStatus.erpVersion">&middot; {{ erpConnectionStatus.erpVersion }}</span>
          </button>
          <button @click="closeSlideOver" type="button" value="off" class=" headerButtons inline-flex items-center mr-4 px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white  ">
            + {{ $t('header.addWidget.title') }}
          </button>
          <button @click="toggleDatePicker" type="button" value="off" class="headerButtons inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white headerButtons  ">
            <svg xmlns="http://www.w3.org/2000/svg" class="group-hover:text-gray-300 mr-3 flex-shrink-0 h-4 w-4 " fill="none" viewBox="0 0 24 24" stroke="currentColor"
                 stroke-width="{2}">
              <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            {{dateInformation}}
          </button>
        </div>
      </div>
    </div>
</template>

<script setup>
import {defineProps, defineEmits, ref, onMounted} from "vue";
import HeaderWarnings from "@/components/HeaderWarnings";
import ApiService from "@/services/ApiService";
let apiService = new ApiService;

let emit = defineEmits(["clickedToggleDatePicker", "closeSlideOver"]);
defineProps( {
  dateInformation: String
})
let style = ref(" justify-self-end  ")
onMounted(async ( ) =>{
  if (screen.width < 625){
    style.value = " justify-center space-y-1"
  }
  warnings.value = await apiService.getWarnings()
  erpConnectionStatus.value = await apiService.getErpConnectionStatus()
  if (!erpConnectionStatus.value.isEventRecent) console.log(`No recent connection event found (${erpConnectionStatus.value.eventDate})`)
  loaded.value = true
})

let showDatepicker = ref(false);
let warnings = ref([]);
let loaded = ref(false)
let erpConnectionStatus = ref({})


function toggleDatePicker()
{
  showDatepicker.value = ! showDatepicker.value;
  emit("clickedToggleDatePicker", showDatepicker.value)
}

function closeSlideOver()
{
  emit("closeSlideOver");
}

function navigateToSyncStatus() {
  window.parent.postMessage({ action: 'navigate', path: '/admin/api/task/status?activeMenuItem=sync' }, '*');
}

function displayErpName(erp) {
  switch (erp) {
    case "Dynamics": return "Business Central"
    default : return erp
  }
}
</script>
